import { render, staticRenderFns } from "./ShiftOwnerMenu.vue?vue&type=template&id=39d47720&scoped=true&"
import script from "./ShiftOwnerMenu.vue?vue&type=script&lang=ts&"
export * from "./ShiftOwnerMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftOwnerMenu.vue?vue&type=style&index=0&id=39d47720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d47720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VList,VListItem,VMenu,VProgressCircular,VTooltip})
